var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f;opacity:0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76,12H64a4,4,0,0,0-4-4H36a4,4,0,0,0-4,4H20a4,4,0,0,0,0,8V76A12,12,0,0,0,32,88H64A12,12,0,0,0,76,76V20a4,4,0,0,0,0-8ZM68,76a4,4,0,0,1-4,4H32a4,4,0,0,1-4-4V24H68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36,72a4,4,0,0,0,4-4V36a4,4,0,0,0-8,0V68A4,4,0,0,0,36,72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48,72a4,4,0,0,0,4-4V36a4,4,0,0,0-8,0V68A4,4,0,0,0,48,72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60,72a4,4,0,0,0,4-4V36a4,4,0,0,0-8,0V68A4,4,0,0,0,60,72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.456192513b8305cd0591b769b7e578cd.svg";
export { ForwardRef as ReactComponent };